/**
 * ファイルをダウンロードする
 *
 * @param blob ダウンロードするBlob
 * @param content_disposition ファイル名取得要素
 * @param content_type ファイル種別
 */
export var fileDownload = function (file, content_disposition, content_type) {
    var blob = new Blob([file], { type: content_type });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    var file_name = getFileNameFromContentDisposition(content_disposition);
    if (file_name === '') {
        return;
    }
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    link.onclick = function () {
        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, file_name);
        }
    };
    link.click();
    link.remove();
    // ダウンロードリンクノードを削除する
    URL.revokeObjectURL(url);
};
/**
 * レスポンスのヘッダからファイル名を取得する
 *
 * @param content_disposition ファイル名取得要素
 * @return ファイル名
 */
var getFileNameFromContentDisposition = function (content_disposition) {
    var file_name_regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
    var matches = file_name_regex.exec(content_disposition);
    if (matches !== null && matches[1]) {
        var fileName = matches[1].replace(/['"]/g, '');
        return decodeURI(fileName).replace(/\+/g, ' ');
    }
    else {
        return '';
    }
};
